import React from 'react'
import { Tabs } from 'antd'
import './CustomTabs.css'

const { TabPane } = Tabs

/**
 * CustomTabs component with modern styling for the patient profile
 * Uses BEM-style class names to avoid affecting global styles
 * 
 * @param {Object} props - Component props
 * @param {string} props.activeKey - The currently active tab key
 * @param {Function} props.onChange - Function called when tab is changed
 * @param {React.ReactNode} props.children - Tab panes
 * @param {React.ReactNode} props.tabBarExtraContent - Extra content in tab bar
 * @param {Object} props.style - Additional style for the tabs container
 */
const CustomTabs = ({ activeKey, onChange, children, tabBarExtraContent, style }) => {
  // Container styles
  const containerStyle = {
    padding: '0 24px 16px 0',
    marginBottom: '16px',
    backgroundColor: '#fff',
    ...style
  }

  return (
    <div style={containerStyle} className="patient-profile-tabs-container">
      <Tabs 
        activeKey={activeKey}
        onChange={onChange}
        tabBarExtraContent={tabBarExtraContent}
        type="line"
        className="patient-profile-tabs"
        animated={{ inkBar: true, tabPane: false }}
        styles={{
          inkBar: {
            height: '3px',
            background: '#1890ff',
            bottom: '0',
            zIndex: 1
          },
          tab: {
            height: '48px',
            lineHeight: '48px',
            padding: '0 16px',
            margin: '0 4px 0 0'
          }
        }}
      >
        {children}
      </Tabs>
    </div>
  )
}

// Add TabPane as a static property
CustomTabs.TabPane = ({ children, ...props }) => (
  <TabPane {...props}>
    <div style={{ padding: '16px 0' }}>
      {children}
    </div>
  </TabPane>
)

export default CustomTabs 